{
  "page": {
    "intro": "お店の税金の設定です：すべての価格に含まれる10%、レシートの登録番号、海外注文、免税販売。右の例にすぐ結果が出ます。",
    "load_failed": "税金の設定を読み込めませんでした。"
  },
  "tabs": {
    "label": "税金の画面",
    "settings": "設定",
    "calendar": "法律の日付",
    "tax_free": "免税販売",
    "report": "月次レポート",
    "documents": "書類をさがす"
  },
  "jct": {
    "title": "消費税",
    "intro": "お店の価格は常に10%の消費税込み（税込）です。税額はレシートごとに1回だけ計算されます。",
    "rate": "税率",
    "rate_value": "{{rate}}% — すべての価格に含まれます",
    "rate_help": "日本の法律では税込価格の表示（総額表示）が必要です。税率は固定で、ここでは変更できません。",
    "rate_note": "法律で決まっています。すべてのカード・BOXで同じです。",
    "rounding": "端数処理",
    "rounding_per_document_floor": "レシートごとに1回、切り捨て",
    "rounding_per_document_round_half_up": "レシートごとに1回、四捨五入",
    "rounding_per_document_ceil": "レシートごとに1回、切り上げ",
    "rounding_help": "インボイス制度では、端数処理はレシートごと・税率ごとに1回だけです。お店は切り捨てです。",
    "rounding_note": "発行済みのレシートは元の端数処理のままです。",
    "registration": "登録番号",
    "registration_help": "適格請求書発行事業者としての番号：Tと13桁の数字。すべてのレシートに印刷されます。",
    "registration_hint": "保存する前に国税庁の公表サイトで確認してください。",
    "registration_placeholder": "これは見本の番号です。お店の本当の登録番号を入力してください。",
    "registration_format": "登録番号は「T」と13桁の数字です。",
    "business_name_ja": "事業者名（日本語）",
    "business_name_en": "事業者名（英語）",
    "business_name_help": "登録番号で登録されている名前です。レシートに印刷されます。",
    "tax_office": "税務署",
    "tax_office_help": "お店が申告する税務署です。",
    "fiscal_year": "課税期間の始まり",
    "fiscal_year_help": "お店の課税期間の最初の月です。",
    "month": "{{month}}月",
    "business_type": "お店の運営者",
    "business_type_help": "法人か個人事業者か。個人だけの特例があります。",
    "business_corporation": "法人",
    "business_individual": "個人事業者",
    "method": "売上の税額の計算方法",
    "method_help": "割戻しは売上の合計から、積上げはレシートごとの税額を合計します。税理士と決めてください。",
    "method_warimodoshi": "割戻し計算",
    "method_warimodoshi_desc": "月の売上合計から税額を計算します。",
    "method_tsumiage": "積上げ計算",
    "method_tsumiage_desc": "レシートごとの税額を合計します。",
    "ask_accountant": "税理士に相談",
    "simplified": "簡易課税",
    "simplified_desc": "税務署に届け出た期間だけ。",
    "simplified_help": "小規模事業者のための簡単な計算方法です。開始日と終了日が必要です。",
    "simplified_from": "簡易課税の開始日",
    "simplified_to": "簡易課税の終了日",
    "small_business": "小規模事業者の特例",
    "small_business_help": "2割特例・3割特例は数年間、納める税を減らします。いつ終わるかは法律の日付で決まります。",
    "small_none": "なし",
    "small_2wari": "2割特例",
    "small_2wari_ended": "この特例は終わりました。",
    "small_3wari": "3割特例",
    "small_3wari_desc": "個人事業者だけ、法律で決まった年だけ。",
    "small_3wari_not_now": "この日付では使えません。",
    "small_until": "{{date}}まで",
    "credit": "登録番号のない人からの買取",
    "credit_help": "登録番号のない人からカードを買うと、税額の一部しか控除できません。法律で段階的に下がります。",
    "credit_value": "税額の{{rate}}%を控除できます（1人あたり年{{cap}}まで）",
    "credit_next": "{{rate}}%に変わる日："
  },
  "export": {
    "title": "海外注文",
    "intro": "海外に送るカードは、証拠を保管すれば消費税なし（輸出免税）で販売できます。",
    "policy": "海外のお客様の価格",
    "policy_help": "通常の価格から税を抜くか、市場ごとに別の価格を使います。",
    "strip_tax": "税抜で販売",
    "strip_tax_example": "{{price}}のカードは海外で{{base}}になります。",
    "market_price": "海外価格を別に設定",
    "market_price_desc": "市場ごとに価格があります（マーケットで設定）。",
    "evidence_required": "すべての海外注文で輸出の証拠を保管する",
    "evidence_required_desc": "保管されるまで注文ページで発送の証拠をお願いします。",
    "evidence_help": "証拠がないと、国内の販売として10%の税がかかります。",
    "postal_limit": "輸出許可書なしで郵便で送れる上限",
    "postal_limit_help": "1個あたりこの金額までは、郵便の引受記録と伝票控えで足ります。超えると輸出許可書が必要です。",
    "postal_limit_hint": "現在の法律では20万円です。",
    "block_cash": "海外注文は現金不可",
    "block_cash_desc": "現金では誰が払ったか証明できないため、輸出免税では受け付けません。"
  },
  "taxfree": {
    "title": "訪日客への免税販売",
    "intro": "店頭だけ。輸出物品販売場の許可が必要です。",
    "licensed": "輸出物品販売場の許可がある",
    "licensed_desc": "店頭での免税販売をオンにします。",
    "licensed_help": "訪日客に免税で販売するための税務署の許可です。",
    "license_granted_on": "許可年月日",
    "license_granted_on_help": "税務署の許可書に書かれた日付です。新しい制度の前の許可か後の許可かをシステムが判断します。",
    "filing": "電子化届出をした日",
    "filing_help": "許可のあるお店は電子化届出をしないと許可が失効します。",
    "filing_deadline": "まだです — 残り{{days}}日、期限",
    "regime_now": "今日の免税のしくみ",
    "regime": {
      "exemption": "免税価格方式 — お客様は税抜で支払います",
      "refund": "リファンド方式 — お客様は税込で支払い、税関確認後に税が戻ります"
    },
    "regime_switch": "{{days}}日後にリファンド方式に変わります：",
    "regime_unknown": "今は法律の日付を読めませんでした。",
    "regime_overridden": "手動で設定されています（法律の日付に従っていません）。",
    "regime_refund_explain": "リファンド方式では、お客様が商品を国外に持ち出したと税関が確認したら（90日以内）、お店が税を返します。",
    "override": "法律の日付に従う",
    "override_help": "「自動」のままにしてください。税務署から指示があったときだけ手動で選びます。",
    "override_auto": "自動",
    "override_auto_desc": "法律の日付に自動で切り替わります。",
    "override_warning": "2つの方式を同時に使う期間はありません。税務署の指示があったときだけ使ってください。",
    "exemption_ended": "免税価格方式（旧方式）は終わりました。いまは「リファンド方式」だけです。「自動」に戻して保存してください。",
    "min_amount": "免税になる最低金額",
    "min_amount_help": "この金額（税抜）未満の購入は免税になりません。",
    "high_value": "シリアル番号が必要な金額",
    "high_value_help": "この価格以上の商品はシリアル番号・鑑定番号を記録します。",
    "sender_id": "送信者識別符号",
    "sender_id_help": "購入記録情報を送るために税務署から受け取る番号です。",
    "store_id": "販売場識別符号",
    "store_id_help": "免税店としてのこのお店の番号です。",
    "cert": "送信用証明書の参照",
    "cert_replace": "新しい証明書の参照",
    "cert_help": "送信用の証明書の保管場所です。最後の4文字だけ表示します。",
    "cert_hint": "空のままなら保存済みのものを使います。",
    "refund_provider": "税を返すのは",
    "refund_provider_help": "お店自身か、還付代行会社か。",
    "provider_self": "お店",
    "provider_self_desc": "税関確認後にスタッフが送金します。",
    "provider_agent": "還付代行会社",
    "provider_agent_desc": "会社がお店の代わりにお客様に払います。",
    "agent_name": "還付代行会社の名前",
    "self_refund_warning": "海外の人へお金を返すには許可（資金移動業）が必要な場合があります。まず税理士・行政書士に相談してください。",
    "refund_method": "いつもの返し方",
    "refund_method_help": "返すたびに選べます。これは最初の選択です。",
    "files_now": "税務署との接続ができるまで、購入記録情報のファイルは免税販売のページで作ります。",
    "records_link": "免税販売を開く"
  },
  "refund_method": {
    "bank_transfer": "銀行振込",
    "cash_agent": "代理人から現金",
    "agent_company": "還付代行会社",
    "stripe_refund": "カード返金",
    "stripe_later": "カード決済の接続と一緒に使えます"
  },
  "advanced": {
    "title": "税理士向け",
    "intro": "オーナーが税理士と一度だけ決める設定です。",
    "journal": "免税販売の記帳",
    "journal_help": "帳簿で課税から免税に移すタイミングです。",
    "journal_per_record": "販売ごと",
    "journal_monthly": "月に1回",
    "consigned": "委託販売のカード",
    "consigned_help": "個人のカードを税金上どう扱うか。",
    "consigned_out_of_scope": "お店の手数料だけ課税",
    "consigned_out_of_scope_desc": "レシートに「委託品／インボイス対象外」と表示します。",
    "consigned_gross": "販売価格すべて課税",
    "consigned_gross_desc": "税理士の指示があるときだけ。",
    "commission_tax": "お店の手数料は税込",
    "commission_tax_desc": "委託手数料は税込の金額です。"
  },
  "preview": {
    "title": "例",
    "updating": "例を更新中",
    "loading": "例を読み込み中…",
    "owner_only": "例はオーナーだけが見られます。",
    "domestic": "国内販売",
    "export": "海外発送",
    "taxfree": "店頭免税",
    "price": "価格",
    "base": "税抜",
    "tax": "消費税 {{rate}}%",
    "tax_zero": "消費税 0%",
    "customer_pays": "お客様の支払い",
    "export_market": "お客様の市場の価格を使います。",
    "refund_after_customs": "税関確認後に返す額",
    "taxfree_exemption_note": "お客様は店頭で税抜の価格を払います。",
    "taxfree_refund_note": "税関が確認したらお店が税を返します（90日以内）。",
    "rounding_per_document_floor": "税額はレシートごとに1回計算、切り捨て。",
    "rounding_per_document_round_half_up": "税額はレシートごとに1回計算、四捨五入。",
    "rounding_per_document_ceil": "税額はレシートごとに1回計算、切り上げ。"
  },
  "save": {
    "button": "保存",
    "changes_other": "{{count}}件の変更",
    "no_changes": "変更なし",
    "effective_from": "適用開始日",
    "effective_from_hint": "空 = 明日から。今日にできるのは今日まだレシートを出していないときだけ。",
    "confirm_title": "税金の設定を保存しますか？",
    "confirm_from": "{{date}}からのすべてのレシートが新しい設定になります。",
    "confirm_tomorrow": "明日からのすべてのレシートが新しい設定になります。",
    "confirm": "保存",
    "saved": "保存しました — {{date}}から適用。",
    "replaced": "保存しました — {{date}}の予定の設定を置き換えました。",
    "scheduled": "予定の変更（バージョン{{version}}）を表示しています。適用開始：",
    "read_only": "この設定は見るだけです。変更できるのはオーナーだけです。"
  },
  "fields": {
    "invoiceRegistrationNumber": "登録番号",
    "businessNameJa": "事業者名（日本語）",
    "businessNameEn": "事業者名（英語）",
    "storeNameEn": "店名（英語）",
    "taxOffice": "税務署",
    "businessType": "お店の運営者",
    "fiscalYearStartMonth": "課税期間の始まり",
    "salesTaxMethod": "売上の税額の計算方法",
    "simplifiedTaxationFlag": "簡易課税",
    "simplifiedTaxationFrom": "簡易課税の開始日",
    "simplifiedTaxationTo": "簡易課税の終了日",
    "smallBusinessSpecial": "小規模事業者の特例",
    "exportPricingPolicy": "海外のお客様の価格",
    "exportEvidenceRequired": "輸出の証拠を保管",
    "exportBlockCash": "海外注文は現金不可",
    "postalExportLimit": "郵便の上限",
    "taxFreeLicensed": "免税の許可",
    "electronicFilingDoneAt": "電子化届出",
    "taxFreeRegimeOverride": "免税のしくみ（手動）",
    "clearTaxFreeRegimeOverride": "免税のしくみ（自動）",
    "taxFreeMinAmount": "免税の最低金額",
    "taxFreeHighValueThreshold": "シリアル番号が必要な金額",
    "ntaSenderId": "送信者識別符号",
    "ntaStoreId": "販売場識別符号",
    "ntaClientCertRef": "送信用証明書",
    "refundProvider": "税を返すのは",
    "refundAgentName": "還付代行会社",
    "defaultRefundMethod": "いつもの返し方",
    "journalMode": "免税販売の記帳",
    "consignedIndividualTreatment": "委託販売のカード",
    "commissionIncludesTax": "手数料は税込"
  },
  "issues": {
    "invalid_registration_number": "登録番号は「T」と13桁の数字です。",
    "registration_number_placeholder": "見本の番号です。お店の本当の登録番号を入力してください。",
    "registration_number_unverified": "お客様に見せる前に国税庁の公表サイトでこの番号を確認してください。",
    "taxfree_ids_missing": "免税店には送信者識別符号と販売場識別符号（または還付代行会社）が必要です。",
    "electronic_filing_pending": "電子化届出がまだです — しないと許可が失効します。",
    "simplified_taxation_dates_required": "簡易課税には開始日と終了日が必要です。",
    "wari2_ended": "この日付では2割特例は終わっています。",
    "wari3_not_allowed": "3割特例は個人事業者だけ、法律で決まった年だけです。",
    "feature_disabled": "カード返金はカード決済の接続と一緒に使えます。別の方法を選んでください。",
    "rounding_change_consistency": "発行済みのレシートは元の端数処理のままです。",
    "rounding_change_period_boundary": "端数処理の変更は次の課税期間からです。",
    "field_locked": "法律で決まっていて変更できません。",
    "settings_not_configured": "まだ税金の設定が保存されていません。標準の値を表示しています。",
    "taxfree_license_date_missing": "許可年月日を入れてください。新しい制度より前の許可は、期限までに電子化届出をしないと失効します。",
    "taxfree_license_lapsed": "この許可は失効しています。新しい制度より前の許可で、期限までに電子化届出の記録がありません。届出をした場合はその日を入れてください。していない場合は免税販売をオフにしてください。",
    "taxfree_refund_completion_missing": "システムはまだ訪日客への税の返金を完了できません。準備ができるまで免税販売をしないか、還付代行会社を使ってください。",
    "taxfree_refund_override_early": "リファンド方式は法律の日付のカレンダーの日から始まります。それより前に使えるかは確認されていません。先に税理士に確認してください。",
    "other": "この値を確認してください。"
  },
  "calendar": {
    "title": "法律の日付",
    "load_failed": "法律の日付を読み込めませんでした。",
    "rules_today": "今日のルール",
    "today": "今日",
    "days_left_other": "あと{{count}}日",
    "days_ago_other": "{{count}}日前",
    "unverified": "未確認",
    "todo": "やること",
    "source": "出典",
    "accessed": "{{date}}確認",
    "mark_done": "完了にする",
    "done_on": "{{date}}に完了",
    "saved": "保存しました。",
    "code": {
      "credit_80_ends": "80%控除の最終日",
      "wari2_ends": "2割特例の終了",
      "credit_70_starts": "控除が70%に",
      "taxfree_new_license_open": "新しい免税許可の申請開始",
      "taxfree_exemption_ends": "免税価格方式の最終日（電子化届出の期限）",
      "taxfree_refund_starts": "リファンド方式の開始",
      "credit_50_starts": "控除が50%に",
      "shogaku_tokurei_ends": "少額特例の終了",
      "credit_30_starts": "控除が30%に",
      "credit_0_starts": "控除の終了"
    },
    "effect": {
      "credit": "登録番号のない人からの買取：税額の{{rate}}%を控除できます。",
      "wari2_ends": "2割特例が使えなくなります。",
      "taxfree_new_license_open": "新しい免税許可を税務署に申請できます。",
      "taxfree_exemption_ends": "お客様が店頭で税抜で払う最後の日。電子化届出はこの日までに。",
      "taxfree_refund_starts": "お客様は税込で払い、税関確認後（{{days}}日以内）にお店が税を返します。",
      "shogaku_tokurei_ends": "1万円未満の仕入れにもインボイスが必要になります。",
      "other": "この日に税金のルールが変わります。"
    }
  },
  "alert_action": {
    "review_buylist_credit": "買取価格を税理士と確認してください。",
    "review_small_business_special": "特例を税理士と確認してください。",
    "decide_taxfree_licence": "免税許可を申請するか決めてください。",
    "file_electronic_notification": "税務署に電子化届出をしてください。",
    "brief_pos_staff_refund_regime": "新しい免税の手順を店頭スタッフに説明してください。",
    "decide_refund_method": "税の返し方を決めてください。",
    "retry_taxfree_refund": "返金をもう一度試してください。",
    "other": "税理士と確認してください。"
  },
  "rules": {
    "taxfree_regime": {
      "exemption": "免税：免税価格方式（お客様は税抜で支払い）。",
      "refund": "免税：リファンド方式（税込で支払い、税関確認後に返金）。"
    },
    "nonregistered_credit_rate": "登録番号のない人からの買取：{{rate}}%控除、1人あたり年{{cap}}まで。",
    "wari2": {
      "available": "2割特例が使えます。",
      "ended": "2割特例は終わりました。"
    },
    "shogaku_tokurei": {
      "available": "1万円未満の仕入れはインボイス不要（少額特例）。",
      "ended": "少額特例は終わりました。"
    },
    "wari3": {
      "available_for_individual": "個人事業者は3割特例が使えます。"
    },
    "taxfree_new_license_open": "新しい免税許可を申請できます。",
    "regime_overridden": "手動で{{override}}に設定（法律の日付では{{calendar}}）。",
    "other": "税金のルールがあります。"
  },
  "records": {
    "title": "免税販売",
    "intro": "すべての免税販売：税務署への送信、90日以内の税関確認、税の返金。",
    "views": "どの販売",
    "view": {
      "pending": "税関確認待ち",
      "due": "還付待ち（確認済）",
      "deadline_soon": "期限7日以内",
      "send_failed": "送信失敗",
      "failed": "還付失敗",
      "refunded": "還付済",
      "expired": "期限切れ",
      "all": "すべて"
    },
    "view_help": {
      "pending": "まだ税関確認がありません。期限が近い順。",
      "due": "税関確認から3日以上 — 今すぐ税を返してください。",
      "deadline_soon": "90日の期限が1週間以内に終わります。",
      "send_failed": "購入記録情報が税務署に届いていない、または遅れて送信。",
      "failed": "返金できませんでした — もう一度試すか別の方法を選んでください。",
      "refunded": "税を返しました。",
      "expired": "期限内に税関確認がなく、課税のままです。",
      "all": "すべての免税販売、新しい順。"
    },
    "order": "注文",
    "purchased": "購入日",
    "buyer": "購入者",
    "base": "税抜",
    "tax": "消費税",
    "regime": "方式",
    "sent": "税務署への送信",
    "late": "事後送信",
    "customs": "税関",
    "deadline": "期限",
    "status": "状態",
    "days_left_other": "あと{{count}}日",
    "deadline_today": "今日まで",
    "deadline_passed": "期限切れ",
    "search": "検索",
    "search_placeholder": "注文番号・追跡番号",
    "empty": "ここに免税販売はありません。"
  },
  "ui_status": {
    "refund_pending": "待ち",
    "refunded": "還付済",
    "taxable_final": "課税のまま",
    "exempted": "免税",
    "cancelled": "取消",
    "failed": "還付失敗",
    "written_off": "終了（雑益）"
  },
  "transmission": {
    "pending": "送信待ち",
    "exported": "ファイルに出力",
    "sent": "送信済",
    "accepted": "受付済",
    "rejected": "拒否",
    "cancelled": "取消"
  },
  "transmission_kind": {
    "send": "送信",
    "cancel": "取消",
    "resend": "再送信"
  },
  "customs": {
    "not_applicable": "不要",
    "pending": "待ち",
    "confirmed": "税関確認済",
    "denied": "確認なし",
    "expired": "期限切れ"
  },
  "customs_source": {
    "manual": "スタッフが入力",
    "csv": "ファイルから",
    "nta_api": "税務署から"
  },
  "buyer_type": {
    "short_stay": "短期滞在",
    "landing_permit": "上陸許可",
    "jp_nonresident": "海外在住の日本人"
  },
  "goods": {
    "general": "一般物品",
    "consumable": "消耗品"
  },
  "refund_request": {
    "requested": "送金中",
    "refunded": "支払済",
    "failed": "失敗",
    "superseded": "置き換え"
  },
  "drawer": {
    "title": "免税販売 {{number}}",
    "loading": "読み込み中…",
    "purchased": "購入日",
    "open_order": "注文を開く",
    "refund_ready": "税関確認済 — 今、税を返せます。",
    "refund_wait_customs": "税関確認の後で返してください。",
    "refund_closed_expired": "期限内に税関確認がなく、返金はありません。",
    "refund_done": "税を返しました。",
    "exemption_note": "免税価格方式：お客様は税抜で支払いました。ここでは送信だけを確認します。",
    "buyer": "購入者",
    "passport": "旅券",
    "passport_hidden": "旅券番号は本人確認ができるスタッフだけに表示されます。",
    "passport_show": "30秒表示",
    "passport_hides": "あと{{seconds}}秒で非表示",
    "items": "商品",
    "item": "商品",
    "qty": "数量",
    "serial": "シリアル",
    "total": "合計",
    "sending": "税務署への送信",
    "transmission_no": "送信番号 {{no}}",
    "customs": "税関",
    "checked_at": "確認日",
    "manual_until_api": "税務署との接続ができるまではスタッフが入力します。",
    "refund_title": "税の返金",
    "refund_amount": "返す消費税相当額：",
    "refunded_at": "返金日",
    "refund_sending": "還付を処理中です（税金の設定のいつもの方法）— 振込の手順は注文にあります。",
    "retransmit": "再送信",
    "resend": "返品後の訂正（洗替）",
    "confirmed": "税関確認済にする",
    "denied": "免税不可",
    "write_off": "返さずに終了",
    "refund": "還付を記録",
    "done": {
      "confirmed": "税関確認済 — 還付を開始しました。",
      "denied": "保存しました — 課税のままです。",
      "retransmit": "再送信を予約しました。",
      "resend": "訂正を送信中です。",
      "write_off": "終了しました。",
      "refund": "返金を送りました。"
    },
    "refund_change": "返金方法を変更",
    "wait_sending": "購入記録情報がまだ送信されていません。先に送信してください。税関確認はその後です。"
  },
  "customs_dialog": {
    "confirmed_title": "税関確認済にしますか？",
    "confirmed_desc": "お客様が商品を国外に持ち出したと税関が確認しました。",
    "denied_title": "免税不可にしますか？",
    "denied_desc": "税関の確認がありません — 課税のままです。",
    "checked_at": "確認日時",
    "ref": "参照番号（任意）",
    "reason": "理由",
    "checked_at_invalid": "確認日は購入日より前、または期限より後にはできません。"
  },
  "resend": {
    "title": "返品後の訂正（洗替）",
    "desc": "送信済みの購入記録情報を取り消し、残りの商品を送り直します。",
    "keep": "お客様が持っている商品",
    "partial": "チェックした商品を送り直します。",
    "full": "チェックなし — 販売全体を取り消します。",
    "reason": "理由（任意）",
    "submit": "訂正を送信"
  },
  "write_off": {
    "title": "返さずに終了しますか？",
    "consequence": "税はお店に残り、雑益として記帳されます。お客様に連絡できないときだけ使ってください。"
  },
  "refund_dialog": {
    "title": "還付を記録",
    "desc": "お客様に税をどう返すか選んでください。",
    "amount": "返す消費税相当額：",
    "method": "方法",
    "bank_desc": "お店がお客様の銀行に送金します。",
    "cash_agent_desc": "代理人がお客様に現金を渡します。",
    "agent_desc": "還付代行会社がお客様に払います。",
    "bank_on_file": "お客様の口座情報は保存済みです。",
    "bank_name": "銀行",
    "branch_name": "支店",
    "account_type": "口座の種類",
    "futsu": "普通",
    "toza": "当座",
    "account_number": "口座番号／IBAN",
    "account_name": "口座名義",
    "swift": "SWIFTコード",
    "bank_missing": "先にお客様の口座情報を入力してください。",
    "bank_needs_kyc": "口座情報を入力できるのは本人確認ができるスタッフだけです。",
    "next": "次へ",
    "confirm_title": "税を返しますか？",
    "confirm": "{{method}}でお客様に税を返します。履歴に保存されます。",
    "confirm_button": "返金する"
  },
  "export_files": {
    "open": "税務署へのファイル",
    "title": "購入記録情報のファイル",
    "desc": "税務署との接続ができるまで、期間の販売をファイルにしてアップロードします。",
    "from": "開始日",
    "to": "終了日",
    "version": "ファイルの形式",
    "version_help": "リファンド方式で販売したものは新しい形式、それより前の販売は旧形式です。",
    "version_v2": "リファンド方式の前",
    "version_v3": "リファンド方式",
    "make": "ファイルを作る",
    "made": "ファイルを作りました：{{count}}件。",
    "made_list": "作ったファイル",
    "none": "まだファイルはありません。",
    "count_other": "{{count}}件",
    "status_exported": "未提出",
    "status_submitted": "提出済",
    "file_csv": "表計算ファイル",
    "file_json": "データファイル",
    "file_manifest": "確認用ファイル一覧",
    "reference": "税務署の受付番号",
    "mark": "提出済にする",
    "marked": "提出済として保存しました。",
    "submitted_on": "提出日"
  },
  "customs_import": {
    "open": "税関確認結果をファイルで取込",
    "title": "税関確認結果をファイルで取込",
    "desc": "まずファイルを確認します。取り込むまで何も変わりません。",
    "columns": "列：追跡番号または送信番号、結果（confirmed / denied）、確認日、参照番号。",
    "choose": "ファイルを選ぶ",
    "checking": "ファイルを確認中…",
    "summary": "{{total}}行中{{ok}}行を取り込めます。",
    "line": "行",
    "record": "販売",
    "result": "結果",
    "outcome": "確認",
    "apply_other": "{{count}}行を取り込む",
    "applied_other": "{{count}}件を更新しました。",
    "outcomes": {
      "ok": "OK",
      "not_found": "販売が見つかりません",
      "already_final": "決定済み",
      "not_applicable": "リファンド方式の販売ではありません",
      "not_transmitted": "まだ送信していません",
      "duplicate": "ファイル内で重複",
      "invalid": "読めない行",
      "after_deadline": "期限後"
    }
  },
  "report": {
    "title": "免税販売 月次レポート",
    "intro": "日本時間の1か月の免税販売 — 帳簿と税理士のために。",
    "month": "月",
    "previous": "前の月",
    "next": "次の月",
    "of_month": "{{month}}",
    "csv": "ダウンロード（CSV）",
    "pdf": "ダウンロード（PDF）",
    "pdf_busy": "PDFを作成中…",
    "pdf_after_month": "月のPDFは翌月1日（日本時間）から作れます。それまでは数字が変わるため、CSVかこの画面をお使いください。",
    "pdf_ready": "PDF {{number}} を保存しました",
    "pdf_ready_updated": "数字が変わったので新しい版（第{{version}}版）のPDF {{number}} を作りました",
    "count_other": "{{count}}件",
    "tax": "消費税",
    "incl": "税込",
    "journal_moved": "課税→免税（税関確認済）",
    "refunded": "還付済",
    "outstanding": "還付残",
    "expired": "課税のまま（期限切れ）",
    "written_off": "返さずに終了（雑益）",
    "late": "事後送信",
    "by_status": "状態ごとの販売",
    "unsubmitted": "未提出のファイル",
    "open_files": "ファイルを開く",
    "rows": "販売",
    "disclaimer": "帳簿の補助です。申告の数字は税理士が確認します。"
  },
  "evidence": {
    "title": "輸出免税の証憑",
    "page_title": "輸出免税の証憑",
    "page_intro": "この注文を免税のままにするための書類です。7年間保管します。",
    "status": {
      "not_required": "不要",
      "missing": "証憑なし",
      "partial": "証憑が一部不足",
      "complete": "証憑あり"
    },
    "ship_to": "発送先",
    "declared": "申告価格",
    "paid_by": "支払い",
    "shipped": "発送日",
    "payment_class": {
      "cash": "現金",
      "traceable": "カード・振込",
      "unknown": "不明"
    },
    "not_required": {
      "settings_evidence_not_required": "税金の設定で証憑を保管しないことになっています。",
      "order_cancelled": "注文は取り消されました。",
      "picked_up": "店頭受取 — 国内の販売です。",
      "other": "この注文に輸出の証憑は必要ありません。"
    },
    "warning": {
      "RECIPIENT_DAY_TOTAL_OVER_LIMIT": "同じ受取人に今日{{total}} — 輸出許可書が必要です。",
      "domestic_address": "住所が日本国内です（転送業者？）— 輸出ではありません。",
      "other": "この注文の証憑を確認してください。"
    },
    "checklist": "保管する証憑",
    "kind": {
      "carrier_record": "郵便の引受記録",
      "shipping_slip_copy": "伝票控え",
      "export_permit": "輸出許可書",
      "import_permit_equivalent": "到着国の輸入許可書相当"
    },
    "kind_help": {
      "carrier_record": "追跡番号付きで発送すると自動で追加されます。",
      "shipping_slip_copy": "お客様控えの伝票の写真。",
      "export_permit": "郵便の上限を超えるとき、またはクーリエが申告するとき必要です。",
      "import_permit_equivalent": "支払った人を証明できないとき（現金）に必要です。"
    },
    "still_missing": "まだありません",
    "kept": "保管済み",
    "file_kept": "ファイル保管済み",
    "from_shipment": "発送から",
    "remove": "削除",
    "remove_aria": "{{kind}}を削除",
    "remove_title": "この証憑を削除しますか？",
    "remove_consequence": "注文の免税の証拠がなくなる場合があります。追加から24時間以内だけ削除できます。",
    "removed": "削除しました。",
    "add_photo": "{{kind}}の写真・PDF",
    "type_number": "代わりに番号を入力",
    "reference": "書類の番号",
    "save_reference": "保存",
    "added": "証憑を保管しました。",
    "now_complete": "すべての証憑を保管しました — 注文は完了です。",
    "carrier_auto": "追跡番号付きで発送済にすると自動で入ります。",
    "invoice_hint": "コマーシャルインボイスは注文の書類から印刷します。",
    "open_order": "注文を開く",
    "retention": "お店の書類保管場所に7年間保管します（電帳法）。"
  },
  "queue": {
    "title": "輸出免税・証憑待ち",
    "intro": "証憑がそろっていない海外注文 — 発送が古い順。30日を過ぎると赤。",
    "tab_open": "証憑なし",
    "tab_complete": "完了",
    "order": "注文",
    "status": "証憑",
    "missing": "不足しているもの",
    "age_other": "{{count}}日前",
    "empty": "すべての輸出証憑を保管済みです。",
    "empty_complete": "完了した注文はまだありません。",
    "drawer_title": "{{number}}の証憑"
  },
  "documents": {
    "title": "書類をさがす（電帳法）",
    "intro": "お店が発行したレシート・請求書・精算書はすべて7年間ここに保管されています。日付・金額・取引先で（組み合わせても）さがして、保管されたファイルをダウンロードできます。",
    "form_label": "書類の検索",
    "date": "取引年月日",
    "date_from": "開始日",
    "date_to": "終了日",
    "amount": "取引金額",
    "amount_min": "下限",
    "amount_max": "上限",
    "amount_hint": "円（整数）",
    "counterparty": "取引先（お客様・委託者）",
    "counterparty_placeholder": "名前の一部でも大丈夫です",
    "number": "書類番号",
    "number_placeholder": "例：R-2026-000123",
    "search": "さがす",
    "clear": "クリア",
    "problem": {
      "dates_reversed": "開始日が終了日より後になっています。",
      "amounts_reversed": "下限の金額が上限より大きくなっています。"
    },
    "found_other": "{{count}}件",
    "total": "合計",
    "conditions_other": "{{count}}つの条件で検索",
    "none": "該当する書類はありません。",
    "none_hint": "日付の範囲を広げるか、条件を減らしてください。",
    "col": {
      "date": "取引年月日",
      "kind": "種類",
      "number": "番号",
      "counterparty": "取引先",
      "amount": "取引金額",
      "file": "ファイル"
    },
    "version": "第{{version}}版",
    "replaced": "新しい版があります",
    "hold": "保存延長中",
    "open_source": "取引を開く",
    "download": "{{number}}をダウンロード（PDF）",
    "not_ready": "作成中…",
    "pdf_saved": "{{number}}を保存しました",
    "csv": "一覧をダウンロード（CSV）",
    "more": "もっと見る",
    "kept": "お店が発行したファイルそのものです。変更されることはありません。訂正は元の書類を参照する新しい版になります。",
    "types": {
      "ryoshusho": "領収書",
      "kani_invoice": "適格簡易請求書",
      "tekikaku_invoice": "適格請求書",
      "henkan_invoice": "返還インボイス",
      "refund_note": "返金明細",
      "commercial_invoice": "コマーシャルインボイス（輸出）",
      "customs_declaration": "税関告知書（CN22/CN23）",
      "packing_slip": "納品書",
      "tax_free_slip": "免税販売の記録",
      "taxfree_explanation": "免税のご案内",
      "refund_evidence": "免税返金の証明",
      "kaitori_meisai": "買取明細書",
      "itaku_keiyaku": "委託契約書",
      "seisan_sho": "精算書",
      "z_report": "日計表",
      "kobutsu_style15": "古物台帳（様式第15号・受入れ）",
      "kobutsu_style16": "古物台帳（様式第16号・払出し）",
      "taxfree_monthly_report": "免税販売 月次レポート",
      "supplier_invoice": "仕入明細書",
      "layaway_deposit_receipt": "預り証"
    }
  }
}
